import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72efb26d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ds-card__header-content" }
const _hoisted_2 = {
  key: 0,
  class: "ds-card__title"
}
const _hoisted_3 = {
  key: 1,
  class: "ds-card__header-actions"
}

import { computed } from 'vue';

interface Props {
  title?: string;
  flat?: boolean;
  bordered?: boolean;
  shadow?: 'sm' | 'md' | 'lg' | 'xl';
  showDivider?: boolean;
  footerAlign?: 'left' | 'center' | 'right' | 'between' | 'around' | 'evenly';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSCard',
  props: {
    title: { default: '' },
    flat: { type: Boolean, default: false },
    bordered: { type: Boolean, default: true },
    shadow: { default: 'md' },
    showDivider: { type: Boolean, default: false },
    footerAlign: { default: 'right' }
  },
  setup(__props: any) {

const props = __props;



const cardClasses = computed(() => ({
  [`shadow-${props.shadow}`]: !props.flat,
  'ds-card--no-divider': !props.showDivider,
}));

const cardStyle = computed(() => ({
  borderRadius: 'var(--radius-lg)',
  backgroundColor: 'var(--bg-primary)',
}));

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: _ctx.flat,
    bordered: _ctx.bordered,
    class: _normalizeClass(cardClasses.value),
    style: _normalizeStyle(cardStyle.value)
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.header || _ctx.title)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.showDivider)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "ds-card__header q-pb-sm"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _createElementVNode("div", _hoisted_1, [
                        (_ctx.title)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
                          : _createCommentVNode("", true),
                        (_ctx.$slots.headerActions)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _renderSlot(_ctx.$slots, "headerActions")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 3
                }))
              : _createCommentVNode("", true),
            (_ctx.showDivider)
              ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_q_card_section, { class: "ds-card__body" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content", {}, () => [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }),
      (_ctx.$slots.footer && _ctx.showDivider)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createBlock(_component_q_card_actions, {
            key: 2,
            class: "ds-card__footer",
            align: _ctx.footerAlign
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "footer")
            ]),
            _: 3
          }, 8, ["align"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["flat", "bordered", "class", "style"]))
}
}

})